<template>
    <a-modal
        :width="modalWidth"
        :visible="visible"
        :title="title"
        destroyOnClose
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
        @cancel="handleCancel"
        :cancelText="$t('关闭')"
        wrapClassName="ant-modal-cust-warp"
        >
        <template slot="footer">
            <a-button key="close" @click="handleCancel">
                {{ $t('关闭') }}
            </a-button>
        </template>
        <div>
            <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :scroll="{x: true}"
            class="j-table-force-nowrap"
            @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
            </span>
        </a-table>
        <partCommand-old-modal ref="modalForm" @ok="modalFormOk"></partCommand-old-modal>
        <PartCommandCommonModal ref="modalForm1" @ok="modalFormOk"></PartCommandCommonModal>
        </div>
    </a-modal>
</template>

<script>
import PartCommandOldModal from '@/views/part/modules/PartCommandOldModal'
import PartCommandCommonModal from '@/views/part/modules/PartCommandCommonModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import {isUndefined} from '@/utils/validate'
import {dataFlagObj,reportStatusObj} from '@/utils/constants/protocolConstant'
import {meterTypeObj} from '@/utils/constants/commonConstant'

export default {
    components: {
        PartCommandOldModal,
        PartCommandCommonModal
    },
    mixins:[JeecgListMixin],
    data() {
        return{
            title:this.$t("命令队列"),
            meterTypeObj,
            visible: false,
            model: {},
            modalWidth:950,
            confirmLoading: false,
            disableMixinCreated: true,
            url: {
                list: "/jeecg-charge/model/partCommand/list",
                exportXlsUrl: "/jeecg-charge/meter/meterUserinfo/exportXls"
            },
        }
    },
    computed: {
        // i18n：列定义使用 computed 以响应语言切换
        columns () {
            return [
                {
                    title: '#',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 60,
                    align: "center",
                    customRender: (t, r, index) => {
                        return parseInt(index) + 1;
                    }
                },
                {
                    title: this.$t('命令标识'),
                    align: "center",
                    dataIndex: 'cmd',
                    customRender: (text) => {
                        return dataFlagObj[text] ? this.$t(dataFlagObj[text]) : ''
                    }
                },
                {
                    title: this.$t('表类型'),
                    align: "center",
                    dataIndex: 'mtName',
                    // customRender:function (text) {
                    //     let data = meterTypeObj
                    //     return data[text]
                    // }
                },
                {
                    title: this.$t('表编号'),
                    align: "center",
                    dataIndex: 'meterId'
                },
                {
                    title: this.$t('通讯状态'),
                    align: "center",
                    dataIndex: 'status',
                    customRender: (t, r, index) => {
                        let data = reportStatusObj
                        if(isUndefined(typeof data[t])) {
                            return this.$t("其他")
                        }
                        return this.$t(data[t])
                    }
                },
                {
                    title: this.$t('发送时间'),
                    align: "center",
                    dataIndex: 'sendTime'
                },
                {
                    title: this.$t('接收回应时间'),
                    align: "center",
                    dataIndex: 'receiveTime'
                },
                // {
                //     title: '指令标记帧',
                //     align:"center",
                //     dataIndex: 'mid'
                // },
                {
                    title: this.$t('操作'),
                    dataIndex: 'action',
                    align: "center",
                    flex: "right",
                    width: 147,
                    scopedSlots: { customRender: 'action' },
                }
            ]
        }
    },
    methods: {
        edit(record) {
            this.queryParam.meterId = record.meterId
            this.visible = true;
            this.model = Object.assign({}, record);
            this.loadData(1)
        },
        handleCancel() {
            this.close()
        },
        close () {
            this.$emit('close');
            this.visible = false;
        },
        handleSubmit() {   
        },
        handleDetail(record) {
            if(record.meterType=='Y28'){
                this.$refs.modalForm1.edit(record)
                this.$refs.modalForm1.title = this.$t('命令详情')
            }else{
                this.$refs.modalForm.edit(record)
                this.$refs.modalForm.title = this.$t('命令详情')
            }
        }
    }
}
</script>